export class CmhUser {
    public CategoryId: number;
    public CategoryNumber: number;
    public CategoryDescription: string;

    public BadLoginTries: number;
    public CmhUserId: number;
    public CreatedBy: string;
    public Email: string;
    public FirstName: string;
    public IsActive: boolean;
    public IsAdmin: boolean;
    public IsInternal: boolean;
    public IsPlantUser: boolean;
    public LastLogin: Date;
    public LastName: string;
    public LastRetailer: string;
    public ModifiedBy: Date;
    public PasswordLastChanged: Date;
    public UserName: string;
    public fullName: string;
    public retailerName: string;
    public retailerNumber: string;
    public cmhUser: string;
    public availableRetailers: Array<any>;

    public availableFacilities: Array<any>;
    public Roles: Array<string>;
    public CurrentRetailer: Array<any>;
    public AvailableRetailers: Array<any>;
    public CmhUserRoles?: Array<any>;
    public CurrentRetailerNumber?: string;

    constructor() {

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/model/cmhuser.ts